import { DatabaseOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps, Space } from 'antd';
import { strings } from '../../../lang';
import { useSalesChannelState } from '../../../store/header-state';
import { SalesChannel } from '../../../dto/model';
import { getSalesChannelLabel } from '../../../utils/inbound-utils';
import { useShallow } from 'zustand/shallow';
import { HEADER_SALES_CHANNEL_MENU_ORDER } from '../../../constants/special-sales-channels';

const items: MenuProps['items'] = HEADER_SALES_CHANNEL_MENU_ORDER.map((key) => ({
  label: getSalesChannelLabel(key),
  key,
  icon: <DatabaseOutlined />,
}));

const SalesChannelDropdown = () => {
  const [, salesChannelLabel, setSalesChannel] = useSalesChannelState(useShallow((state) => [state.salesChannel, state.salesChannelLabel, state.setSalesChannel]));

  const handleMenuClick = (e: any) => {
    const selected = items.find((item) => item?.key === e.key);
    if (!selected) {
      return;
    }
    setSalesChannel(selected.key! as SalesChannel);
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <div>
      <p>{strings.salesChannelDropdownLabel}</p>
      <Dropdown menu={menuProps}>
        <Button>
          <Space>
            <DatabaseOutlined />
            {salesChannelLabel}
            <DownOutlined />
          </Space>
        </Button>
      </Dropdown>
    </div>
  );
};

export default SalesChannelDropdown;
